// extracted by mini-css-extract-plugin
export var filterIncDec = "_45-0";
export var leftBorder = "_45-1";
export var rightBorder = "_45-2";
export var stringInput = "_45-3";